import { render } from "./ClaimNotFound.vue?vue&type=template&id=030909cf"
import script from "./ClaimNotFound.vue?vue&type=script&lang=js"
export * from "./ClaimNotFound.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__